//    *GENERAL IMPORTS*   //
import { ThunkAction } from 'redux-thunk'
import { AppStateType, InferActionsTypes } from 'Redux/ReduxStore'

import { BlogType } from 'Redux/Types/BlogsTypes'

////////////////////////////////////////////////////////////////////////

const initialState = {
  blogs: [] as Array<BlogType>,
  blogInfo: {} as BlogType,
  isLoading: true as boolean,
}

type initialStateType = typeof initialState

// *REDUCER* //
const BlogsReducer = (
  state = initialState,
  action: ActionTypes,
): initialStateType => {
  if (action.type === 'SET_BLOGS') {
    return {
      ...state,
      blogs: action.blogs,
    }
  }

  if (action.type === 'SET_BLOG_INFO') {
    return {
      ...state,
      blogInfo: action.projectInfo,
    }
  }

  if (action.type === 'SET_LOADING_STATE') {
    return {
      ...state,
      isLoading: action.loadingState,
    }
  }

  return state
}

export default BlogsReducer

///////////////////////////////////////////////////////////////////////

type ActionTypes = InferActionsTypes<typeof ActionCreatorsList>

//    *ACTION CREATORS*   //
export const ActionCreatorsList = {
  setBlogsActionCreator: (blogs: Array<BlogType>) =>
    ({
      type: 'SET_BLOGS',
      blogs,
    } as const),

  setBlogInfoActionCreator: (projectInfo: BlogType) =>
    ({
      type: 'SET_BLOG_INFO',
      projectInfo,
    } as const),

  setLoadingStateActionCreator: (loadingState: boolean) =>
    ({
      type: 'SET_LOADING_STATE',
      loadingState,
    } as const),
}

//    *THUNKS*   //
type ThunkType = ThunkAction<Promise<void>, AppStateType, unknown, ActionTypes>

export const getBlogsThunkCreator = (): ThunkType => {
  return async (dispatch, getState, { getFirebase, getFirestore }: any) => {
    const firestore = getFirestore()

    const blogsRef = firestore.collection('blogs').orderBy('date')
    const data: Array<BlogType> = await blogsRef
      .get()
      .then((querySnapshot: any) => {
        let list = querySnapshot.docs.map((doc: any) => ({
          ...doc.data(),
          id: doc.id,
        }))
        return list
      })

    dispatch(ActionCreatorsList.setBlogsActionCreator(data))
  }
}

export const getBlogInfoThunkCreator = (ID: string): ThunkType => {
  return async (dispatch, getState, { getFirebase, getFirestore }: any) => {
    const firestore = getFirestore()
    dispatch(ActionCreatorsList.setLoadingStateActionCreator(true))

    const projectsRef = firestore.collection('blogs').doc(ID)
    const data = await projectsRef.get().then((snapshot: any) => {
      console.log(snapshot.data())
      return snapshot.data()
    })

    dispatch(ActionCreatorsList.setLoadingStateActionCreator(false))
    dispatch(ActionCreatorsList.setBlogInfoActionCreator(data))
  }
}
